import { DatePicker, Form, Input, InputNumber, Select, message } from "antd";
import { useEffect, useState } from "react";
import {
  useAddAccountMutation,
  useEditAccountMutation,
} from "src/app/services/finance";
import { IAccount, IAddAccount } from "src/app/services/finance/type";
import { PlusIcon } from "src/assets/svg";
import CustomButton from "src/components/common/button";
import CustomModal from "src/components/common/modal";
import ModalFooter from "src/components/common/modal/ModalFooter";
import ModalHeader from "src/components/common/modal/ModalHeader";
import { currencyOptions } from "src/static/constants";
import { accountFormData } from "../constants";
import { useTranslation } from "react-i18next";
import DateFormItem from "src/components/form/common/DateFormItem";
import dayjs from "dayjs";
import { dateFormat } from "src/components/filter/FilterDate";
import { amountFormatter, amountParser } from "src/static/form";

interface Props {
  handleGet: () => void;
  editableData?: IAccount;
  setEditableData: React.Dispatch<React.SetStateAction<IAccount | undefined>>;
}

function AddAccount({ handleGet, editableData, setEditableData }: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { t } = useTranslation();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setEditableData(undefined);
    form.resetFields();
  };

  //Form section
  const [addAccount, { isSuccess: addStatus }] = useAddAccountMutation();
  const [editAccount, { isSuccess: editStatus }] = useEditAccountMutation();
  const [form] = Form.useForm();
  const onFinish = (val: IAddAccount) => {
    if (editableData)
      editAccount({
        id: editableData.id,
        body: {
          ...val,
          start_date: dayjs(val?.start_date).format(dateFormat),
        },
      });
    else
      addAccount({
        ...val,
        start_date: dayjs(val?.start_date).format(dateFormat),
      });
  };

  useEffect(() => {
    if (addStatus) {
      message.success("Akkount muvaffaqiyatli qo'shildi!");
      closeModal();
      handleGet();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addStatus]);

  useEffect(() => {
    if (editStatus) {
      message.success(
        `${editableData?.title} akkount muvaffaqiyatli tahrirlandi!`,
      );
      handleGet();
      closeModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editStatus]);

  //Set data for edit
  const handleSet = () => {
    if (editableData) {
      showModal();
      form.resetFields();
      let { title, currency, initial_balance, start_date } = editableData;
      form.setFieldsValue({
        title,
        currency,
        initial_balance,
        start_date: start_date ? dayjs(start_date) : null,
      });
    }
  };

  useEffect(() => {
    handleSet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editableData]);

  return (
    <div className="add">
      <CustomButton className="content-top-btn" height={38} onClick={showModal}>
        <div className="content-top-btn-content">
          <PlusIcon /> {t("common.add")}
        </div>
      </CustomButton>
      <CustomModal
        open={isModalOpen}
        width={640}
        onCancel={closeModal}
        centered={true}
      >
        <ModalHeader
          title={`${
            editableData
              ? editableData.title + " " + t("subInfo.editAccount")
              : t("subInfo.addAccount")
          }`}
        />

        <Form
          form={form}
          name="normal_login"
          className="form-form"
          onFinish={onFinish}
          layout={"vertical"}
          requiredMark={false}
        >
          {accountFormData(t).map((item) => {
            if (item.name == "start_date")
              return (
                <DateFormItem
                  name={item.name}
                  label={item.label}
                  message={item.message}
                  key={item.label}
                />
              );
            else
              return (
                <Form.Item
                  name={item.name}
                  label={item.label + "*"}
                  rules={[{ required: true, message: item.message }]}
                  className="full"
                  key={item.label}
                >
                  {item.name === "currency" ? (
                    <Select allowClear options={currencyOptions} />
                  ) : item.name === "initial_balance" ? (
                    <InputNumber
                      formatter={amountFormatter}
                      parser={amountParser}
                      style={{ width: "100%" }}
                      min={
                        editableData
                          ? Number(editableData.initial_balance) -
                              editableData.balance >
                            0
                            ? Number(editableData.initial_balance) -
                              editableData.balance
                            : 0
                          : 0
                      }
                    />
                  ) : (
                    <Input type={"text"} />
                  )}
                </Form.Item>
              );
          })}
          <ModalFooter onCancel={closeModal} />
        </Form>
      </CustomModal>
    </div>
  );
}

export default AddAccount;
